// @flow

import React, { type Node } from 'react';
import styled, { css } from 'styled-components';
import chevronDownSrc from './chevron-down.svg';

type VerticalAccordionItemProps = {|
  children: Node,
  id: string,
  onToggle: (key: string) => void,
  title: Node,
  isLast: boolean,
  isOpen: boolean,
|};

export function VerticalAccordionItem({
  children,
  id,
  isLast,
  isOpen,
  onToggle,
  title,
}: VerticalAccordionItemProps): Node {
  return (
    <>
      <Header onClick={(e) => onToggle(id)} isLast={isLast} isOpen={isOpen}>
        <div>{title}</div>
        <div><ChevronDownImage isOpen={isOpen} src={chevronDownSrc} alt="chevron down icon" /></div>
      </Header>
      <Content isLast={isLast} isOpen={isOpen}>
        {children}
      </Content>
    </>
  );
}

const Header = styled.div`
  border-bottom: 1px solid rgb(220,225,230);
  color: ${props => props.theme.colors.secondaryGray};
  background-color: ${props => props.theme.colors.white};
  cursor: pointer;
  display: flex;
  font-weight: 600;
  font-family: ${props => props.theme.fontFamily.display};
  font-size: 1.25em;
  justify-content: space-between;
  padding: 1em;
  ${props => props.isLast && !props.isOpen && css`
    border-bottom: none;
  `}
  border-radius: 5px;
`;

const Content = styled.div`
  background-color: ${props => props.theme.colors.terciaryGray};
  border-bottom: 1px solid ${props => props.theme.colors.secondaryGray[0]};
  ${props => props.isLast && css`
    border-bottom: none;
    border-radius: 0 0 5px 5px;
  `}
  display: ${props => props.isOpen ? 'block' : 'none'};
  padding: 1.25em;
`;

const ChevronDownImage = styled.img`
  ${props => props.isOpen && css`
      transform: rotateX(180deg);
  `}
`;
